import { Link } from 'react-router-dom';

interface SidebarProps {
  isOpen: boolean;
  onToggle: () => void;
}

export default function Sidebar({ isOpen, onToggle }: SidebarProps) {
  return (
    <div className={`${isOpen ? 'w-64' : 'w-20'} bg-gray-800 transition-all duration-300`}>
      <div className="p-4">
        <div className="flex items-center justify-between">
          {isOpen && <h1 className="text-xl font-bold text-white">Byte</h1>}
          <button onClick={onToggle} className="text-white">
            {isOpen ? '←' : '→'}
          </button>
        </div>

        <nav className="mt-8">
          <SidebarLink icon="📊" label="Dashboard" to="/dashboard" isOpen={isOpen} />
          <SidebarLink icon="📁" label="Projects" to="/dashboard/projects" isOpen={isOpen} />
          <SidebarLink icon="👥" label="Users" to="/dashboard/users" isOpen={isOpen} />
          <SidebarLink icon="⚙️" label="Settings" to="/dashboard/settings" isOpen={isOpen} />
          <SidebarLink icon="📤" label="Log out" to="/auth/login" isOpen={isOpen} />
        </nav>
      </div>
    </div>
  );
}

interface SidebarLinkProps {
  icon: string;
  label: string;
  to: string;
  isOpen: boolean;
}

function SidebarLink({ icon, label, to, isOpen }: SidebarLinkProps) {
  return (
    <Link
      to={to}
      className="flex items-center text-gray-300 hover:text-white hover:bg-gray-700 rounded-lg p-3 mb-1"
    >
      <span className="text-xl">{icon}</span>
      {isOpen && <span className="ml-3">{label}</span>}
    </Link>
  );
} 